import { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { SimpleModal } from "../SimpleModal/SimpleModal";
import { Shot } from "../../../TeamReport/ShotDetailModal/types";
import RichShotDetailContent from "../../../TeamReport/ShotDetailModal/RichShotDetailContent";
import { useLeagueEnvironment } from "../../../data/LeagueEnvironmentProvider";
import { ExplorerEnvironment } from "../../../data/Cache";
import "../../../TeamReport/ShotDetailModal/ShotDetailModal.scss";
import "../../../TeamReport/DetailModal/DetailModal.scss";

interface ShotDetailChartDialogProps {
  shots: Shot[];
  isOpen: boolean;
  handleClose: () => void;
  title: string;
}

export default function ShotDetailChartDialog({
  shots,
  isOpen,
  handleClose,
  title,
}: ShotDetailChartDialogProps) {
  const environment = useLeagueEnvironment();
  const showCollegeLine = environment === ExplorerEnvironment.DRAFT;

  const onClose = useCallback(
    (_event: object, _reason: string) => {
      handleClose();
    },
    [handleClose]
  );

  if (shots.length === 0) {
    return (
      <SimpleModal
        isOpen={isOpen}
        handleClose={onClose}
        title={title}
        maxWidth="xl"
        dialogClassName="detail-modal--dialog"
      >
        <Box className="empty-state">
          <Typography color="text.secondary">
            No shots found for this query.
          </Typography>
        </Box>
      </SimpleModal>
    );
  }

  return (
    <SimpleModal
      isOpen={isOpen}
      handleClose={onClose}
      title={title}
      maxWidth="xl"
      dialogClassName="detail-modal--dialog"
    >
      <RichShotDetailContent
        shots={shots}
        showCollegeLine={showCollegeLine}
      />
    </SimpleModal>
  );
}
